<button fd-button [class]="!isExpand ? 'header-custom-icon' : ''" [fdType]="isExpand ? 'emphasized': 'transparent'" name="activateFullScreen" (click)="toggleFullScreen()" title="{{isExpand ? 'Full Screen' : 'Exit Full Screen'}}">
    <app-icon [icon]="[$any('workspace'), $any( isExpand ? 'expand' : 'collapse')]" size="lg"></app-icon>
</button>
